import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
// import { Dropdown, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import AppContext from "contexts/AppContext";
import auth from "services/auth";
import { __ } from "services/Translator";
import moneyFormatter from "services/moneyFormatter";
import ls from "services/ls";
import { Dropdown, Accordion } from "react-bootstrap";
import Chat from "elements/Chat";

export default function RightSidebarShortLong(props) {
  const params = useParams();
  const { updateUserObj } = React.useContext(AppContext);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const tab = params.tab;
  const [activeTab, setActiveTab] = useState("account-details");
  const location = useLocation();
  const activeMenu = location.pathname;
  //   alert(props.openLeftSidebar);
  // const showSidebar = props.showLeftSidebar;
  // const setShowSidebar = props.setShowLeftSidebar;
  const [showSidebar, setShowSidebar] = useState(props.showLeftSidebar);

  const logout = async () => {
    await auth.logout();
    await updateUserObj();
    setIsAuthenticated(auth.isAuthenticated);
  };

  const [animationStarts, setAnimationStarts] = useState(false);
  useEffect(() => {
    if (props.showLeftSidebar) {
      setShowSidebar(props.showLeftSidebar);
      setAnimationStarts(true);
      setTimeout(function () {
        setAnimationStarts(false);
      }, 3000);
    }
  }, [props]);

  const [showBalanceAsFiat, setShowBalanceAsFiat] = useState(
    ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
  );

  const [fiatCurrencyToDisplay, setFiatCurrencyToDisplay] = useState(
    ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
  );

  useEffect(() => {
    setShowBalanceAsFiat(
      ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
    );
    setFiatCurrencyToDisplay(
      ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
    );
  }, [props.trigger]);

  //Player Chat
  const [chatInPopup, setChatInPopup] = useState(null);

  return (
    <>
      {/* <div className="navSidebar fullHide opend"> */}
      <div
        className={
          "navSidebar " + (props.showRightSidebar ? "opend inFull" : "fullHide")
        }
      >
        <div className="navSidebarContent">
          {isAuthenticated && (
            <Chat
              {...props}
              chatInPopup={chatInPopup}
              setChatInPopup={setChatInPopup}
            />
          )}
        </div>
      </div>

      {showSidebar && (
        <div
          className="invisible_overlay"
          onClick={() => setShowSidebar(false)}
        ></div>
      )}
    </>
  );
}
